"use client";

import { useEffect, useState } from "react";
import strapiSingleAttribute from "@/api/strapiSingleAttribute";
import Image from "next/image";
import styles from './JourneyForGraduation.module.scss'
import {imgPathReplace} from "@/helpers/imgPathReplace";
import GraduationCard from "../GraduationCard/GraduationCard";

export default function JourneryForGraduationContent({
  Features,
  ImageAttr,
  heading,
  isCampusImmersionPage = false 
}: {
  Features: any;
  ImageAttr: any;
  heading: string;
  isCampusImmersionPage? :boolean;
}) {
  const [openSection, setOpenSection] = useState<number | null>(0);
  const [image, setImage] = useState<any>(null);
  const [features, setFeatures] = useState<any>(null);

  useEffect(() => {
    const image = Array.isArray(ImageAttr)
      ? ImageAttr[openSection || 0]?.MainImage
      : ImageAttr?.source;

    setImage(strapiSingleAttribute(image));
  }, [openSection]);

  useEffect(() => {
    const features = Array.isArray(ImageAttr)
      ? ImageAttr.map((item: any) => ({
          Title: item?.Title,
          Subtitle: item?.Subtitle,
          Image: item?.SecondaryImage,
        }))
      : Features;

    setFeatures(features);
  }, []);

  return (
    <div className="md:grid md:grid-cols-2 gap-4 lg:flex lg:gap-10 mt-16 ">
      <div className="lg:basis-[45%] lg:shrink-0">
        <GraduationCard
          data={features}
          openSection={openSection}
          setOpenSection={setOpenSection}
          heading={heading}
          isCampusImmersionPage={isCampusImmersionPage}
        />
      </div>
      <div className={` rounded-2xl lg:flex-grow ${styles.JourneyForGraduation__ImageContainer} ${isCampusImmersionPage?'border-none':''}`}>
        <img
          src={imgPathReplace(image?.url)}
          alt={ImageAttr?.alt || image?.alternativeText || "Journey"}
          className="object-cover w-full xl:h-full md:h-full"
          loading="lazy"
          title="Journey"
        />
      </div>
    </div>
  );
}
